/**
 * This bootstrap file is used for both frontend and backend
 */

import _ from 'lodash'
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'popper.js'; // Required for BS4
import 'bootstrap';
import 'bootstrap-select';
import 'summernote';

import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.flash.js';

import bootbox from 'bootbox';
import Dinero from 'dinero.js';

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

export const isProduction = () => {
    return env === 'production';
};

if (isProduction()) {
    Sentry.init({
        dsn: 'https://5b2ea99b51454078b324229c5a5037ad@o450194.ingest.sentry.io/5434461',
        integrations: [
            new Integrations.BrowserTracing(),
        ],
        tracesSampleRate: 1.0,
    });
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = $;
window.Swal = Swal;
window._ = _; // Lodash
window.bootbox = bootbox;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Dinero = Dinero;
window.Dinero.defaultCurrency = "GBP";
window.Dinero.defaultPrecision = 2;
window.Dinero.globaleLocale = 'en-GB';
//window.Dinero.globalFormat = '£0,0.00';

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
